import {useQueries} from 'react-query';
import {
  fetchReasonForFailureAnalysis,
  fetchCardAnalysis,
  fetchChartAnalysis,
  fetchConversionRateAnalysis,
  fetchPercentageAnalysis,
  fetchCountryDistributionAnalysis,
} from '../requests/queries/verifications';

/**
 * Custom hook to fetch multiple verification analysis data points concurrently.
 * @param {Object} params - The query parameters for the analysis requests.
 * @param {boolean} enabled - Whether the queries should be enabled.
 * @returns {Array} An array of useQueryResult objects.
 */
export const useVerificationsAnalysis = ({params, enabled}) => {
  const analysisQueries = [
    {
      queryKey: ['failure-reason-analysis', {...params}],
      queryFn: () => fetchReasonForFailureAnalysis({params}),
      enabled: enabled,
    },
    {
      queryKey: ['card-verification-analysis', {...params}],
      queryFn: () => fetchCardAnalysis({params}),
      enabled: enabled,
    },
    {
      queryKey: ['chart-verification-analysis', {...params}],
      queryFn: () => fetchChartAnalysis({params}),
      enabled: enabled,
    },
    {
      queryKey: ['conversion-rate-verification-analysis', {...params}],
      queryFn: () => fetchConversionRateAnalysis({params}),
      enabled: enabled,
    },
    {
      queryKey: ['percentage-verification-analysis', {...params}],
      queryFn: () => fetchPercentageAnalysis({params}),
      enabled: enabled,
    },
    {
      queryKey: ['country-distribution-verification-analysis', {...params}],
      queryFn: () => fetchCountryDistributionAnalysis({params}),
      enabled: enabled,
    },
  ];
  return useQueries(analysisQueries);
};
